<template>
    <b-container 
        class="content" 
        fluid 
    >
            <b-row style="border-bottom:1px solid #ddd;margin-bottom:2em;">
                    <h3>{{ this.$t('userManagement') }}</h3>
            </b-row>
            <b-row style="justify-content:space-between;">
                <b-col cols="8">
                    <ul class="nav nav-tabs">
                        <li v-for="(tab,tabKey) in tabs" class="nav-item p-2" style="cursor: pointer;" :style="tab.isActive ? tab.style.border : ''">
                            <div @click="activate(tabKey)" :class="{'nav-link': true, 'active': tab.isActive}" :style="tab.isActive ? tab.style.tab : ''">{{ tab.name }}  <b-badge pill :style="tab.isActive ? tab.style.badge : ''">{{ tab.users.length }}</b-badge></div>
                        </li>
                    </ul>
                </b-col>
                <b-col cols="4" style="float:right;text-align:right;">
                    <template v-if="anyUserSelected('activeUsers',true)">
                        <b-button key="inviteUser" style="background-color:#41B884;" lg="2" class="pb-2" @click="$refs.inviteBox.show()"><img width="20px" height="20px" src="../../assets/icon/addIcon.svg"/> {{ $t('inviteUser') }}</b-button>
                    </template>
                    <template v-else-if="anyUserSelected('activeUsers',false)">
                        <b-button key="disableUser" style="background-color:#424959;" lg="2" class="pb-2" @click="disableUsers()"><img width="20px" height="20px" src="../../assets/icon/disabledUser_icon.svg"/> {{ $t('disableUser') }}</b-button>
                        <b-button key="deleteUser" style="background-color:#D04D4D;" lg="2" class="pb-2" @click="deleteUsers()"><img width="20px" height="20px" src="../../assets/icon/delete_icon.svg"/> {{ $t('deleteUser') }}</b-button>
                    </template>
                    <template v-else-if="anyUserSelected('disabledUsers',false)">
                        <b-button key="enable" style="background-color:#41B884;" lg="2" class="pb-2" @click="enableUsers()"><img width="20px" height="20px" src="../../assets/icon/enabledUser_icon.svg"/> {{ $t('enableUser') }}</b-button>
                        <b-button key="deleteUser" style="background-color:#D04D4D;" lg="2" class="pb-2" @click="deleteUsers()"><img width="20px" height="20px" src="../../assets/icon/delete_icon.svg"/> {{ $t('deleteUser') }}</b-button>
                    </template>
                    <template v-else-if="anyUserSelected('pendingInvitations',true) && tabs.pendingInvitations.users.length > 0">
                        <b-button key="inviteUser" style="background-color:#41B884;" lg="2" class="pb-2" @click="$refs.inviteBox.show()"><img width="20px" height="20px" src="../../assets/icon/addIcon.svg"/> {{ $t('inviteUser') }}</b-button>
                    </template>
                    <template v-else-if="anyUserSelected('pendingInvitations',false) && tabs.pendingInvitations.users.length > 0">
                        <b-button key="reinvite" style="background-color:#F2AB24;" lg="2" class="pb-2" @click="reInvite()"><img width="20px" height="20px" src="../../assets/icon/reinvite.svg"/> {{ $t('reInvite') }}</b-button>
                        <b-button key="cancelInvite" style="background-color:#022B49;" lg="2" class="pb-2" @click="cancelInvite()"><img width="20px" height="20px" src="../../assets/icon/cancelInvitation_icon.svg"/> {{ $t('cancelInvite') }}</b-button>
                    </template>
                    <template v-else>
                    </template>
                </b-col>
            </b-row>
            <b-modal 
                :title="$t('inviteUser')"
                ref="inviteBox"
                size="lg"
                hide-footer 
                centered
                >
                <b-container class="my-4" fluid>
                    <form ref="form">
                        <b-form-group
                        :label="$t('email')"
                        label-for="email-input"
                        label-class="font-weight-bold pt-0"
                        >
                        <b-form-tags
                            id="email-input"
                            v-model="emails"
                            separator=" ,;"
                            placeholder="Ex: name@mail.com"
                            tag-class="tag-email"
                            addButtonVariant="outline-light"
                            addButtonText=""
                            size="lg"
                            input-type="email"
                            :duplicate-tag-text="$t('alreadyEnteredEmail')"
                            :class="{'is-invalid': error.emailValidation }"
                            disabledAddButton
                            tag-pills
                            no-outer-focus
                            remove-on-delete
                            required
                        >
                        </b-form-tags>
                            <span v-show="error.emailValidation" class="validation-error">{{ $t(emailErrorMessage) }} {{ invalidEmails }}</span>
                        </b-form-group>
                        <span style="padding:1em 0;">
                            <h5 style="color:#A7A7A7;">{{ $t('afterInvitePermCanBeEdit') }}</h5>
                        </span>
                    </form>
                </b-container>
                <hr style="padding-top:5px;">
                <b-row align-h="end">
                    <b-col cols="3">
                        <b-btn size="md" class="mt-3" variant="outline-success" block @click="closeInviteModal()">{{$t('cancel')}}</b-btn>
                    </b-col>
                    <b-col cols="3">
                        <b-btn size="md" class="mt-3" style="background-color:#41B884;" block @click="inviteUsers()">{{$t('sendInvite')}}</b-btn>
                    </b-col>
                </b-row>
            </b-modal>

            <template v-if="tabs.disabledUsers.isActive && tabs.disabledUsers.users.length == 0">
                <div style="padding-top:5em;margin:auto;height:calc(60vh) !important;">
                    <b-row align-v="center">
                        <b-col align-self="center">
                            <b-row>
                                <img style="margin:auto;filter: invert(74%) sepia(0%) saturate(1345%) hue-rotate(252deg) brightness(2.7) contrast(91%) !important;" height="150px" src="../../assets/icon/disabledUser_icon.svg"/>
                            </b-row>
                            <b-row>
                                <b-card style="border:none;margin:auto;width:50%;color:#A7A7A7;padding-top:10px;">
                                    <span style="font-size:20px;"><b>{{ $t('noDisabledUser') }}</b></span>
                                    <br>
                                    <span style="font-size:16px;">{{ $t('canDisableFrom') }} <b style="color:#D118A8;" class="a" v-on:click="activate('activeUsers')">{{ $t('activeUsers') }}</b> {{ $t('canDisableFrom-p2') }}</span>
                                </b-card>
                            </b-row>
                        </b-col>
                    </b-row>
                </div>
            </template>
            <template v-else-if="tabs.pendingInvitations.isActive && tabs.pendingInvitations.users.length == 0">
                <div style="padding:5em;margin:auto;height:calc(60vh) !important;">
                    <b-row>
                        <b-col align-self="center">
                            <b-row>
                                <img style="margin:auto;filter: invert(74%) sepia(0%) saturate(1345%) hue-rotate(252deg) brightness(2.7) contrast(91%) !important;" height="150px" src="../../assets/icon/pending_emptyState.svg"/>
                            </b-row>
                            <b-row>
                                <b-card style="border:none;margin:auto;width:50%;color:#A7A7A7;padding-top:10px;">
                                    <span style="font-size:20px;"><b>{{ $t('noPendingInvitation') }}</b></span>
                                    <br>
                                    <span style="font-size:16px;">{{ $t('canInviteUserFromBelow') }}</span>
                                </b-card>
                            </b-row>
                            <b-row>
                                <b-button style="margin:auto;background-color:#41B884;" key="inviteUser" lg="2" class="pb-2" @click="$refs.inviteBox.show()"><img width="20px" height="20px" src="../../assets/icon/addIcon.svg"/> {{ $t('inviteUser') }}</b-button>
                            </b-row>
                        </b-col>
                    </b-row>
                </div>
            </template>
            <div v-else-if="tabs.pendingInvitations.isActive" class="table-responsive">
                <table class="table table-hover" style="table-layout: fixed; font-size: 0.875em">
                    <thead>
                        <tr>
                            <th style="width: 3em; text-align:left;">
                                <b-form-checkbox
                                    v-model="tabs[activeTab].allUsersSelected"
                                    name="checkbox-1"
                                    :value="true"
                                    :unchecked-value="false"
                                    @change="selectAllUsers($event,activeTab)"
                                />
                            </th>
                            <th style="width: 10em; text-align:left;">{{ $t('user') }}</th> 
                            <th style="width: 8em; text-align:left;">{{ $t('roles') }}</th>
                            <th style="width: 5em; text-align:left;">{{ $t('invite-date') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="user in itemsForList(tabs[activeTab].users)">
                            <td style="text-align:left;">
                                <b-form-checkbox
                                    v-model="user.selected"
                                    name="checkbox-1"
                                    :value="true"
                                    :unchecked-value="false"
                                    @input="selectUser(tabs.activeUsers)"

                                />
                            </td>
                            <td style="text-align:left;cursor:pointer;" class="a" v-on:click="routeToUser(user.id)">{{ user.email }}</td>
                            <td style="text-align:left;">
                                <h5 v-for="userGroup in user.userGroups" style="display:inline-block;padding:1px;">
                                    <b-badge v-if="userGroup=='admin'" pill variant="success" @click="routeUserGroup(userGroup.id)" class="a">{{ translateUserGroup(userGroup) }}</b-badge>
                                    <b-badge v-else pill variant="secondary" @click="routeUserGroup(userGroup.id)" class="a">{{ translateUserGroup(userGroup) }}</b-badge>
                                </h5>
                            </td>
                            <td style="text-align:left;">{{ getFormatedDate(user.inviteDate) }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div v-else class="table-responsive">
                <table class="table table-hover" style="table-layout: fixed; font-size: 0.875em">
                    <thead>
                        <tr>
                            <th style="width: 3em; text-align:left;">
                                <b-form-checkbox
                                    v-model="tabs[activeTab].allUsersSelected"
                                    name="checkbox-1"
                                    :value="true"
                                    :unchecked-value="false"
                                    @change="selectAllUsers($event,activeTab)"
                                />
                            </th>
                            <th style="width: 10em; text-align:left;">{{ $t('user') }}</th>
                            <th style="width: 10em; text-align:left;">{{ $t('job/department') }}</th> 
                            <th style="width: 8em; text-align:left;">{{ $t('roles') }}</th>
                            <th style="width: 5em; text-align:left;">{{ $t('singup-date') }}</th>
                            <th style="width: 5em; text-align:left;">{{ tabs.activeUsers.isActive ? $t('last-login-date') : $t('disable-date') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="user in itemsForList(tabs[activeTab].users)">
                            <td style="text-align:left;">
                                <b-form-checkbox
                                    v-model="user.selected"
                                    name="checkbox-1"
                                    :value="true"
                                    :unchecked-value="false"
                                    @input="selectUser(tabs.activeUsers)"

                                />
                            </td>
                            <td style="text-align:left;cursor:pointer;" class="a" v-on:click="routeToUser(user.id)">
                                <b-row class="my-1">
                                    <b-col sm="3">
                                        <b-avatar class="mr-3" :src="user.profilePic"></b-avatar>
                                    </b-col>
                                    <b-col sm="8">
                                        <b-row>
                                            <b>{{ user.name }}</b>
                                        </b-row>
                                        <b-row>
                                            {{ user.email }}
                                        </b-row>
                                    </b-col>
                                </b-row>
                            </td>
                            <td style="text-align:left;">
                                <b-col>
                                    <b-row>
                                        <b>{{ user.jobTitle }}</b>
                                    </b-row>
                                    <b-row>
                                        {{ user.department }}
                                    </b-row>
                                </b-col>
                            </td>
                            <td style="text-align:left;">
                                <h5 v-for="userGroup in user.userGroups" style="display:inline-block;padding:1px;">
                                    <b-badge v-if="userGroup.type=='admin' || userGroup.type == 'supervisor'" pill @click="routeUserGroup(userGroup.id)" class="a admin-color">{{ translateUserGroup(userGroup) }}</b-badge>
                                    <b-badge v-else pill @click="routeUserGroup(userGroup.id)" class="a role-color">{{ translateUserGroup(userGroup) }}</b-badge>
                                </h5>
                            </td>
                            <td style="text-align:left;">{{ getFormatedDate(user.signupDate) }}</td>
                            <td style="text-align:left;">{{ tabs.activeUsers.isActive ? getFormatedDate(user.lastLoginDate) : getFormatedDate(user.disableDate) }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <b-pagination
                v-model="currentPage"
                :total-rows="tabs[activeTab].users.length"
                :per-page="perPage"
                aria-controls="itemList"
                align="center"
            ></b-pagination>
        </b-container>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';

export default {
    name: 'Users',
    data() {
        return {
            tabs:{
                activeUsers:{
                    isActive:true,
                    users:[],
                    name: this.$t('activeUsers'),
                    allUsersSelected: false,
                    rows: 1,
                    style:{
                        border:{'border-bottom':'3px solid #41B884'},
                        tab:{'color':'#41B884'},
                        badge:{'background-color':'#41B884'}
                    }
                },
                disabledUsers:{
                    isActive:false,
                    users:[],
                    name: this.$t('disabledUsers'),
                    allUsersSelected: false,
                    rows: 1,
                    style:{
                        border:{'border-bottom':'3px solid #022B49'},
                        tab:{'color':'#022B49'},
                        badge:{'background-color':'#022B49'}
                    }
                },
                pendingInvitations:{
                    isActive:false,
                    users:[],
                    name: this.$t('pendingInvitations'),
                    allUsersSelected: false,
                    rows: 1,
                    style:{
                        border:{'border-bottom':'3px solid #D6AA46'},
                        tab:{'color':'#D6AA46'},
                        badge:{'background-color':'#D6AA46'}
                    },
                }
            },
            error:{
                emailValidation: false
            },
            emailErrorMessage: null,
            invalidEmails: null,
            activeTab:'activeUsers',
            isInviteInputValid: null,
            emails: [],
            currentPage: 1,
            perPage: 50,
            translateGroup:['agent','director','supervisor','admin','guest','subAgent','auditor']
            
        };
    },
    methods: {
        routeUserGroup(groupId){
            return this.$router.push({name: 'edit-permissions', params: {id: groupId}});
        },
        translateUserGroup(group){
            let groupName = group.name;
            if(groupName == 'agent') {
                groupName = this.getGroupName('agent');
            }
            return group.type == null ? groupName : this.$t(groupName)
        },
        activate(key){
            this.activeTab = key;
            this.currentPage = 1;
            _.each(this.tabs, (tab,tabKey)=> {
                tab.isActive = key==tabKey;
            });
        },
        routeToUser(userId){
            this.$router.push({name: 'user-profile', params:{user_id:userId}});
        },
        checkFormValidity() {
            const valid = this.$refs.form.checkValidity();
            this.isInviteInputValid = valid;
            return valid;
        },
        emailValidator(){
            let invalidEmailList = [];
            _.each(this.emails, email=>{
                if(!email.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)){
                    invalidEmailList.push(email);
                }
            });
            this.invalidEmails = _.join(invalidEmailList, ', ');
            this.error.emailValidation = !_.isEmpty(invalidEmailList);
            this.emailErrorMessage = 'nonEmailInput';
            if(!this.error.emailValidation){
                this.error.emailValidation = _.isEmpty(this.emails);
                this.emailErrorMessage = 'emptyEmailInput';
            }
        },
        inviteUsers(){
            this.emailValidator();
            if (!this.checkFormValidity() || this.error.emailValidation) {
                return
            }

            this.$Progress.start();
            this.axios
                .post('/user/invite', {emails: this.emails})
                .then(({data}) => {
                    let rejectedEmails = _.filter(_.get(data, 'response'), o=>o!=null);
                    if(_.isEmpty(rejectedEmails))
                    {
                        this.$message({
                            type: 'success',
                            message: this.$t('invitesSended')
                        });
                    }
                    else{
                        this.$message({
                            type: 'warning',
                            message: this.$t('rejectedWhileSendingInvite')+": "+_.join(rejectedEmails, ', ')
                        });
                    }
                    
                    this.emails = [];
                    this.init();
                    this.$refs.inviteBox.hide();
                    this.$Progress.finish();
                })
                .catch(() => {
                    this.$message({
                        type: 'error',
                        message: this.$t('errorOnSendInvite')
                    });
                    this.$Progress.fail();
                });
        },
        closeInviteModal(){
            this.emails = [];
            this.$refs.inviteBox.hide();
        },
        enableUsers(){
            let userIds = _.map(_.filter(this.tabs.disabledUsers.users, user=> user.selected == true), 'id');
            this.$Progress.start();
            this.axios.post('/enableUsers', {'userIds':userIds})
            .then(()=>{
                _.each(this.$store.state.users, user=>{
                    if(_.includes(userIds, user.id)){
                        user.status = 'active';
                    }
                });
                this.configureUsers()
            });
        },
        disableUsers(){
            let userIds = _.map(_.filter(this.tabs.activeUsers.users, user=> (user.selected == true && user.id != this.$store.state.user.id)), 'id');
            if(_.includes(userIds, this.$store.state.user.id)){
                this.$message({
                    type: 'error',
                    message: this.$t('cantDisableSelf')
                });
            }
            else{
                this.$Progress.start();
                this.axios.post('/disableUsers', {'userIds':userIds})
                .then(()=>{
                    _.each(this.$store.state.users, user=>{
                        if(_.includes(userIds, user.id)){
                            user.status = 'disabled';
                        }
                    });
                    this.configureUsers()
                });
            }
        },
        deleteUsers(){
            let userIds = _.map(_.filter(this.tabs[this.activeTab].users, user=> (user.selected == true && user.id != this.$store.state.user.id)), 'id');
            if(_.includes(userIds, this.$store.state.user.id)){
                this.$message({
                    type: 'error',
                    message: this.$t('cantDeleteSelf')
                });
            }
            else{
                this.$Progress.start();
                this.axios.post('/deleteUsers', {'userIds':userIds})
                .then(()=>{
                    _.each(this.$store.state.users, user=>{
                        if(_.includes(userIds, user.id)){
                            user.status = 'deleted';
                            user.disableDate = moment();
                        }
                    });
                    this.configureUsers()
                });
            }
        },
        reInvite(){
            let selectedUsers = _.filter(this.tabs.pendingInvitations.users, user=> user.selected == true);
            let maxTimeInvitedUsers = _.filter(selectedUsers, user=> user.inviteCount>=4);
            if(_.isEmpty(maxTimeInvitedUsers)){
                let userIds = _.map(selectedUsers, 'id');
                this.$Progress.start();
                this.axios.post('/reInviteUsers', {'userIds':userIds})
                .then(()=>{
                    _.each(this.$store.state.users, user=>{
                        if(_.includes(userIds, user.id)){
                            user.status = 'invited';
                            user.inviteDate = moment();
                            user.inviteCount = user.inviteCount+1;
                        }
                    });
                    this.configureUsers()
                    this.$message({
                            type: 'success',
                            message: this.$t('invitesSended')
                        });
                });
            }
            else{
                let incompatibleUserEmails = _.join(_.map(maxTimeInvitedUsers, 'email'), ', ');
                this.$message({
                            type: 'warning',
                            message: this.$t('accessMaxInvitationLimit')+": "+incompatibleUserEmails
                        });
            }
        },
        cancelInvite(){
            let userIds = _.map(_.filter(this.tabs.pendingInvitations.users, user=> user.selected == true), 'id');
            this.$Progress.start();
            this.axios.post('/cancelUserInvites', {'userIds':userIds})
            .then(()=>{
                _.each(this.$store.state.users, user=>{
                    if(_.includes(userIds, user.id)){
                        user.status = 'inviteCanceled';
                    }
                });
                this.configureUsers()
            });
        },
        getFormatedDate(date){
            if(date == null){return '-';}
            if(moment().diff(moment(date), 'month')>1){
                return moment(date).lang(this.$store.state.locale).format("DD MMM YYYY");
            }else{
                return moment(date).lang(this.$store.state.locale).fromNow();
            }
        },
        anyUserSelected(tabName, userSelection){
            return _.isEmpty(_.filter(this.tabs[tabName].users, nUser => nUser.selected)) == userSelection && this.tabs[tabName].isActive == true;
        },
        selectAllUsers(checked,usersGroup){
            let tab = _.clone(this.tabs[usersGroup]);
            _.each(tab.users, user=>{
                _.set(user, 'selected', checked);
            });
            this.tabs[usersGroup] = tab;
        },
        selectUser(tab){
            tab.allUsersSelected = _.isEmpty(_.filter(tab.users, nUser => !nUser.selected));
        },
        itemsForList(data){
            return data.slice(
                (this.currentPage - 1) * this.perPage,
                this.currentPage * this.perPage,
            );
        },
        init(){
            this.$Progress.start();
            this.$store
                .dispatch('getUsers')
                .then(this.configureUsers)
                .then(() => {
                    this.$Progress.finish();
                });
        },
        configureUsers(){
            let users = _.clone(this.$store.state.users);
            this.currentPage = 1;
            _.each(users, user=>{
                user.selected= false;
            });
            this.tabs.activeUsers.users = _.filter(users, user=>user.status == 'active');
            this.tabs.disabledUsers.users  = _.filter(users, user=>user.status == 'disabled');
            this.tabs.pendingInvitations.users  = _.filter(users, user=>user.status == 'invited');
        }
    },
    watch:{
        emails(){
            this.emailValidator();
        }
    },
    created(){
        this.$Progress.start();
            this.$store
                .dispatch('getUsers')
                .then(this.configureUsers)
                .then(() => {
                    this.$Progress.finish();
                });
    }
        
};
</script>

<style lang="scss" scoped>
#tabs .nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {
    border: none;
    background-color: transparent;
    border-color: transparent transparent #f3f3f3;
    font-size: 16px;
    font-weight: bold;
}
.nav-tabs{
    color: #A7A7A7;
}
.nav-tabs:hover, .nav-link:hover {
    border: none;
}
.circle-icon {
    background: #777879;
    border-radius: 50%;
    text-align: center;
    vertical-align: middle;
    height: auto;
    width: auto;
    padding: 10px;
}
.a {
    text-decoration: none;
}
.a:hover {
    text-decoration: underline;
    cursor: pointer;
}
.admin-color{
    background-color: rgba(65, 184, 132, .8);
    border: none;
}
.role-color{
    background-color: rgba(2, 43, 73, .15);
    border: none;
}
.validation-error {
    color: #F14079;
    float: left;
    font-size: .7em;
    font-weight: bold;
}
.is-invalid {
    border-color: #F14079 !important;
}
/deep/ .tag-email {
    color: #4171A9 !important;
    background-color: #E3EFFE !important;
}

// form tags input field width adjustment
// b-from-tags-field typo from bootstrap vue
.form-control /deep/ .b-from-tags-field {
    flex-grow: 1;
}
.form-control /deep/ .btn {
    border: none;
    cursor: default;
    pointer-events: none;
}


</style>

<i18n src="../../i18n/common.json"></i18n>

<i18n>
    {
        "tr": {
            "userManagement": "Kullanıcı Yönetimi",
            "activeUsers": "Aktif Kullanıcılar",
            "disabledUsers": "Engelli Kullanıcılar",
            "pendingInvitations": "Bekleyen Davetler",
            "user": "Kullanıcılar",
            "job/department": "Ünvan/Departman",
            "roles": "Kullanıcı Grupları",
            "singup-date": "Kayıt Tarihi",
            "last-login-date": "Son Çevrimiçi",
            "disable-date": "Engellenme Tarihi",
            "invite-date": "Davet Tarihi",
            "inviteUser": "Kullanıcı Davet Et",
            "disableUser": "Kullanıcıyı Engelle",
            "deleteUser": "Kullanıcıyı Sil",
            "enableUser": "Kullanıcıyı Etkinleştir",
            "noDisabledUser": "Engellenmiş Kullanıcı Yok",
            "canDisableFrom": " ",
            "canDisableFrom-p2": "sekmesinde yer alan 'kullanıcıyı engelle' butonu ile istediğiniz kullanıcıları engelleyebilirsiniz.",
            "noPendingInvitation": "Henüz iş arkadaşlarınızı davet etmediniz!",
            "canInviteUserFromBelow": "Aşağıdaki butonu kullanarak kullanıcıları davet edebilirsiniz",
            "reInvite": "Tekrar Davet Et",
            "cancelInvite": "Davetiyeyi İptal Et",
            "alreadyEnteredEmail": "Bu email zaten girildi",
            "nonEmailInput": "Geçersiz email adresi:",
            "emptyEmailInput": "Lütfen en az bir e-posta adresi girin",
            "sendInvite": "Davet Gönder",
            "add": "Ekle",
            "afterInvitePermCanBeEdit": "Kullanıcıları davet ettikten sonra, kullanıcı izinlerini değiştirebileceksiniz.",
            "accessMaxInvitationLimit": "Bu kullanıcılar izin verilen maksimum davet sayısına ulaştı",
            "errorOnSendInvite": "Davetiyeler gönderilirken hata oluştu",
            "invitesSended": "Seçili kullanıcılar için yeni davet mailleri gönderildi.",
            "rejectedWhileSendingInvite": "Bu kullanıcılar zaten kayıtlı veya 4 defadan fazla davet edildi",
            "cantDisableSelf": "Kendinizi engelleyemezsiniz",
            "cantDeleteSelf": "Kendinizi silemessiniz",
            "email": "E-posta",
            "emailIsRequired": "E-posta gerekli"

        },
        "en": {
            "userManagement": "User Management",
            "activeUsers": "Active Users",
            "disabledUsers": "Disabled Users",
            "pendingInvitations": "Pending Invitations",
            "user": "Users",
            "job/department": "Job Title/Department",
            "roles": "Roles",
            "singup-date": "Signup Date",
            "last-login-date": "Last Login",
            "disable-date": "Disable On",
            "invite-date": "Invitation Date",
            "inviteUser": "Invite User",
            "disableUser": "Disable User",
            "deleteUser": "Delete User",
            "enableUser": "Enable User",
            "noDisabledUser": "No disabled user accounts",
            "canDisableFrom": "You can disable user accounts from the",
            "canDisableFrom-p2": " ",
            "noPendingInvitation": "You haven't invited your colleagues yet!",
            "canInviteUserFromBelow": "Use button below to invite a new user.",
            "reInvite": "Reinvite",
            "cancelInvite": "Cancel Invitation",
            "alreadyEnteredEmail": "This email has already been entered",
            "nonEmailInput": "Invalid email address:",
            "emptyEmailInput": "Please enter at least one e-mail address",
            "sendInvite": "Send Invite",
            "add": "Add",
            "afterInvitePermCanBeEdit": "After inviting users, you will be able to change user permissions.",
            "accessMaxInvitationLimit": "These users have reached the maximum number of invites allowed",
            "errorOnSendInvite": "Error occurred while sending invitations",
            "invitesSended": "New invitation mails have been sent for selected users.",
            "rejectedWhileSendingInvite": "These users are already registered or invited more than 4 times",
            "cantDisableSelf": "You can't disable yourself",
            "cantDeleteSelf": "You can't delete yourself",
            "email": "Email",
            "emailIsRequired": "Email is required"
        }
    }
</i18n>



// WEBPACK FOOTER //
// src/views/Setting/Users.vue